import axios from 'axios';

const getAuthHeader = () => {
  const tokenStr = localStorage.getItem('user');
  if (tokenStr) {
    const token = JSON.parse(tokenStr).token;
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/locations`;

function jsonHeaders() {
  return { ...getAuthHeader(), 'Content-Type': 'application/json' };
}

const getLocations = async () => {
  const response = await axios.get(API_URL, { headers: getAuthHeader() });
  return response.data;
};

const getLocation = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`, { headers: getAuthHeader() });
  return response.data;
};

const createLocation = async (payload) => {
  const response = await axios.post(API_URL, payload, { headers: jsonHeaders() });
  return response.data;
};

const updateLocation = async (id, payload) => {
  const response = await axios.put(`${API_URL}/${id}`, payload, { headers: jsonHeaders() });
  return response.data;
};

const deleteLocation = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

const locationService = {
  getLocations,
  getLocation,
  createLocation,
  updateLocation,
  deleteLocation,
};
export default locationService;
